<template>
  <div class="d-flex flex-column">
    <h5>
      Afbeelding
    </h5>
    <lightbox-preview
      :is-loading="isLoading"
      :images="images"
      :initial-index="0"
      @lightbox-requested="onLightboxRequested"
    />
  </div>
</template>

<script>
import LightboxPreview from '@/components/Shared/LightboxPreview/LightboxPreview.vue';

import ReportDetailStore from '@/store/pages/Report/report-detail-store.js';

export default {
  components: {
    LightboxPreview,
  },

  props: { 
    lightboxRef: { type: Object, default: null, },
  },

  emits: [
    'lightbox-requested'
  ],

  computed: {
    isLoading: () => ReportDetailStore.getters.isLoading,
    images() {
      return ReportDetailStore.getters.images ?? [];
    }
  },

  methods: {
    onLightboxRequested(index) {
      this.$emit('lightbox-requested', index);
    }
  }
}
</script>

<style scoped>
img { max-width: 100%; }
</style>
